import { ShieldCheck } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

type VerifiedBadgeProps = {
  variant?: 'inline' | 'pill'
  className?: string
}

export function VerifiedBadge({ variant = 'inline', className }: VerifiedBadgeProps) {
  if (variant === 'pill') {
    return (
      <Badge className={cn('bg-primary/10 text-primary border border-primary/20 hover:bg-primary/10', className)}>
        <ShieldCheck className="size-3" />
        Verified
      </Badge>
    )
  }

  return <ShieldCheck className={cn('size-4 text-primary shrink-0', className)} />
}
